/* eslint-disable prefer-arrow-callback */

// Frontend only helper. Handlebars.java has its own implementation
// Set messages in javascriptVariables.tag first
// Serverside rendering has a built-in i18n helper

function message(code) {
  try {
    return window.MessageHelper.getMessage(code);
  } catch (e) {
    return '';
  }
}

module.exports = message;

/* eslint-enable prefer-arrow-callback */
